<template>
  <LSection :use-margin="false">
    <template #body>
      <div class="chatbot">
        <div class="heading1">
          Quantum HR Workflow Assistant
          <hr class="gradientLine" />
        </div>
        <LSection :use-margin="false">
          <template #body>
            <div class="text-justify">
              <p>
                Use the embedded assistant below to work through a five-step
                hiring conversation for quantum roles. Your answers are combined
                with real job-market data to produce requirements, job-post
                drafts, and an execution roadmap.
              </p>
              <br />
              <iframe
                :src="assistantUrl"
                frameborder="0"
                class="w-full min-h-[700px] rounded-lg border border-gray-200"
                title="Quantum HR Workflow Assistant"
              ></iframe>
              <p class="mt-4">
                If the embed does not load,
                <a
                  :href="assistantUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="gradientText font-semibold underline"
                >
                  open the assistant in a new tab
                </a>
                .
              </p>
            </div>
          </template>
        </LSection>
      </div>
    </template>
  </LSection>
</template>

<script>
import LSection from "@/components/layout/LSection.vue";
import { onMounted } from "vue";

const ASSISTANT_URL =
  "https://staging.hybridintelligence.eu/quantum-workflow-assistant/";

export default {
  components: {
    LSection,
  },
  setup() {
    const setHeadingColor = () => {
      const heading = document.getElementById("analysisHeader");

      if (heading !== null && heading?.classList) {
        heading.classList.add("text-white");
        heading.classList.remove("text-black");
      }
    };
    onMounted(() => {
      window.addEventListener("scroll", setHeadingColor);
    });
    return {
      assistantUrl: ASSISTANT_URL,
    };
  },
};
</script>

<style scoped></style>
